/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';

import { ButtonOption } from 'types/components/SelectOptions';

interface IOptionProps {
  option?: ButtonOption;
}

const Option: React.FunctionComponent<IOptionProps> = (props: IOptionProps) => {
  const { option } = props;

  return option ? (
    <a
      key={option.id}
      className={`button ${option.disabled ? 'disabled' : ''} ${option.icon ? 'slim-button' : ''}`}
      onClick={option.onClick}
      id={`Option_button___${option.id}`}
    >
      <span className="button-text" id={`Option_buttonText___${option.id}`}>
        {option.text}
      </span>
      {option.icon && <img id={`Option_buttonIcon___${option.id}`} src={option.icon.uri} alt={option.icon.alt} />}
      {option.selected && <span className="option-active" />}
    </a>
  ) : null;
};

export default Option;
